import React, { useRef, useState } from "react";
import { Card, Form, CheckmarkButton } from "@lysaab/ui-2";
import { FormattedMessage } from "react-intl";
import "./IntroEmailCard.scss";
import { sendResumeEmailId } from "../../data/onfido";
export const IntroEmailCard = ({ signupId, language, country, }) => {
    const formRef = useRef();
    const [success, setSuccess] = useState(false);
    return (React.createElement(Card, null,
        React.createElement("p", { className: "email-text" },
            React.createElement(FormattedMessage, { id: "onfido.intro.email.text", values: { country: country.toString() } })),
        React.createElement(Form, { lysaFormRef: formRef, onSubmit: (event) => {
                var _a;
                event.preventDefault();
                if (((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.isValid) && language) {
                    sendResumeEmailId(signupId, language).then(() => {
                        setSuccess(true);
                        setTimeout(() => setSuccess(false), 2000);
                    });
                }
            } },
            React.createElement(CheckmarkButton, { type: "submit", variant: "secondary", className: "block", isSuccessful: success },
                React.createElement(FormattedMessage, { id: "onfido.intro.button.email" })))));
};
